import React from "react";
import { IncomeStatement } from "../../../types/FinanceTypes";
import { CompanyAnalysisIntelligence } from "../../../types/IntelligenceTypes";
import { OrderForm } from "../../../types/OrderFormTypes";
import { Period, SupplierFullCompetitor, SupplierWithEmployee } from "../../../types/SupplierTypes";
import { Competitors } from "./components/Competitors";
import { Context } from "./components/Context";
import { Description } from "./components/Description";
import { Drivers } from "./components/Drivers";
import { EmergingTechnologies } from "./components/EmergingTechnologies";
import { FinancialOverview } from "./components/FinancialOverview";
import { Offerings } from "./components/Offerings";

export interface SupplierOverviewLeftPanelProps {
    profile?: SupplierWithEmployee;
    period?: Period;
    competitors?: SupplierFullCompetitor[];
    showCompetitorEdit?: boolean;
    onEditCompetitor?: (data: SupplierFullCompetitor) => void;
    onPeriodChange?: (overviewOption: Period) => void;
    incomes?: IncomeStatement[];
    analysis?: CompanyAnalysisIntelligence;
    orderForm?: OrderForm;
}

export const SupplierOverviewLeftPanel: React.FC<SupplierOverviewLeftPanelProps> = ({
    profile,
    competitors,
    period = Period.Annually,
    onPeriodChange,
    incomes,
    showCompetitorEdit,
    onEditCompetitor,
    analysis,
    orderForm,
}) => {
    if (!profile) return null;

    return (
        <>
            <Context orderForm={orderForm} />
            <Description content={profile.description} />
            <Offerings data={profile.products} />
            <Drivers data={profile.businessDrivers} />
            <FinancialOverview data={incomes} period={period} onPeriodChange={onPeriodChange} />
            <Competitors
                data={competitors}
                showEdit={showCompetitorEdit}
                onEdit={onEditCompetitor}
            />
            {analysis ? (
                <EmergingTechnologies
                    style={{ marginTop: 20 }}
                    replacements={analysis?.replacements}
                    innovations={analysis?.innovations}
                    newBusinessModels={analysis?.newBusinessModels}
                />
            ) : null}
        </>
    );
};
